var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["d-flex", _vm.className] },
    [
      _c(
        "vs-checkbox",
        {
          staticClass: "d-flex m-0 mr-1",
          attrs: { disabled: _vm.disabled, vsValue: _vm.val, color: _vm.color },
          on: { change: _vm.handleChange },
          model: {
            value: _vm.input,
            callback: function($$v) {
              _vm.input = $$v
            },
            expression: "input"
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68df711c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68df711c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseCheckbox.vue
// module id = null
// module chunks = 